export default __webpack_public_path__ + "static/media/Hyrkanian Grim Skull-Treader.8a572544.jpg";